var _path, _path2, _path3, _path4, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThebornkorea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 134 35"
    },
    viewBox: "0 0 134 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E41E25",
    d: "M30.3 19.8c.5.8.2 1.7-.3 2.5-.1.2-.3.4-.4.6-.4.5-1 .9-1.5 1.2H28l-7.7 4.5V4.4L17.2.2v34.5l13.6-8.5c2.3-1.6 2.8-4.8-.5-6.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 20.2112,
    x2: 29.7507,
    y1: 19.7972,
    y2: 19.7972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2796,
    style: {
      stopColor: "#e41e25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#aa0d13"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M29.7 20.6c-.1-.7-.9-1.2-2.3-1.6-.1 0-4-1-7.2-1.8v1.9c3.3.9 6.9 2 7.2 2.1.6.2 1.2.6 1.5 1.1.6-.5.9-1.2.8-1.7z",
    opacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 13.0743,
    x2: 3.5357,
    y1: 14.895,
    y2: 14.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2796,
    style: {
      stopColor: "#e41e25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#aa0d13"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M3.5 14.1c.1.7.9 1.2 2.3 1.6.1 0 4 1 7.2 1.8v-1.9c-3.3-.9-6.9-2-7.2-2.1-.6-.2-1.2-.6-1.5-1.1-.5.5-.8 1.2-.8 1.7z",
    opacity: 0.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E41E25",
    d: "M3 14.9c-.5-.8-.2-1.7.3-2.5.1-.2.3-.4.4-.6.4-.5 1-.9 1.5-1.2h.1L13 6.1v24.3l3.1 4.2V.1L2.7 8.6c-2.6 1.5-3 4.7.3 6.3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#49494B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.3 8.9h4.2v10.2c0 .7.5 1.2 1.2 1.2h1.2V8.9h4.2V6.7H36.3v2.2zM58.4 6.7V12h-5.8V6.7h-2.4v12.4c0 .7.5 1.2 1.2 1.2h1.2V14.2h5.8v6h2.4V6.6h-2.4zM86.7 13c.4-.2.8-.6 1.2-1.2.4-.6.5-1.3.4-2.1-.1-.8-.5-1.5-1.3-2.1-.7-.6-1.7-.9-2.9-.9h-5.8v12.4c0 .7.5 1.2 1.2 1.2h4.7c1.3 0 2.5-.3 3.3-1 .9-.7 1.4-1.6 1.4-2.6.1-1-.2-1.8-.7-2.4-.5-.7-1-1.1-1.5-1.3zm-6.1-4.1h3.2c.6 0 1.1.1 1.5.4.4.3.5.7.5 1.1 0 .5-.2.9-.5 1.2-.4.3-.9.4-1.5.4h-3.1V8.9zm5.2 8.6c-.4.4-1 .6-1.9.6h-3.3V14.3H84c.8 0 1.4.2 1.8.6.4.4.5.8.5 1.3.1.4-.1.9-.5 1.3zM117.5 13.3c.6-.8.9-1.6.9-2.6 0-1.1-.5-2.1-1.3-2.9-.9-.8-2-1.2-3.2-1.2h-5.6V19c0 .7.5 1.2 1.2 1.2h1.2V15h2l3.7 5.3h2.9l-3.9-5.5c.8-.2 1.5-.7 2.1-1.5zm-4.1-.6h-2.9V8.8h2.9c.7 0 1.3.2 1.8.5s.7.8.7 1.4c0 .7-.2 1.2-.7 1.5-.5.3-1.1.5-1.8.5zM130.5 6.7v9.6L125 6.7h-2.8v12.4c0 .6.5 1.1 1.1 1.2h1.4v-9.6l5.4 9.6h2.9V6.7h-2.5zM98.1 5.7c-4.2 0-7.6 3.4-7.6 7.6 0 4.2 3.4 7.6 7.6 7.6 4.2 0 7.6-3.4 7.6-7.6-.1-4.2-3.5-7.6-7.6-7.6zm0 12.6c-2.8 0-5.1-2.3-5.1-5.1s2.3-5.1 5.1-5.1 5.1 2.3 5.1 5.1c-.1 2.8-2.4 5.1-5.1 5.1zM67.3 14.7v-.4h6.8v-2.2h-6.8V8.9h7.1V6.7H65v12.4c0 .6.5 1.2 1.1 1.2h8.5V18h-7.3v-3.3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#9C9EA0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.6 24.8c.3.4.5.9.5 1.6 0 .6-.2 1.2-.5 1.6-.3.4-.8.6-1.4.6-.6 0-1-.2-1.4-.6-.3-.4-.5-.9-.5-1.6 0-.6.2-1.2.5-1.6.3-.4.8-.6 1.4-.6.6 0 1.1.2 1.4.6zm-.3 2.9c.3-.3.4-.8.4-1.3s-.1-1-.4-1.3c-.3-.3-.6-.5-1.1-.5-.4 0-.8.2-1.1.5-.3.3-.4.8-.4 1.3s.1 1 .4 1.3c.3.3.6.5 1.1.5.5 0 .9-.2 1.1-.5zM47.9 28.5l-1.2-1.7h-1.3v1.7H45v-4.1h1.8c.4 0 .7.1 1 .3.3.2.4.5.4.9 0 .3-.1.5-.3.7-.2.2-.4.3-.7.4l1.2 1.8h-.5zm-.5-2.3c.2-.1.3-.4.3-.6 0-.3-.1-.5-.3-.6-.2-.1-.4-.2-.7-.2h-1.3v1.7h1.3c.3-.1.5-.2.7-.3zM50 28.5v-4.1h.4v4.1H50zM55.5 28.5v-.6c-.1.2-.3.4-.5.5-.2.1-.5.2-.8.2-.6 0-1-.2-1.4-.6-.3-.4-.5-.9-.5-1.6 0-.6.2-1.2.5-1.6.3-.4.8-.6 1.4-.6.5 0 .9.2 1.2.5.3.3.5.6.5.8h-.4c-.1-.2-.2-.4-.4-.6-.2-.2-.5-.3-.9-.3s-.8.2-1.1.5c-.3.3-.4.8-.4 1.3s.1 1 .4 1.3c.3.3.6.5 1 .5s.8-.1 1-.4c.3-.3.4-.6.4-.9v-.2h-1.3v-.3h1.7v2.1h-.4zM57.8 28.5v-4.1h.4v4.1h-.4zM63 28.5l-2.3-3.6v3.5h-.4v-4.1h.5l2.3 3.6v-3.6h.4v4.1H63zM68.6 28.5l-.5-1.1H66l-.5 1.1h-.4l1.7-4.1h.5l1.7 4.1h-.4zM67 24.8l-.9 2.2H68l-1-2.2zM70.6 28.4v-4.1h.4v3.8h2.4v.3h-2.8zM81.3 28.5l-1.8-2.1c-.2.2-.3.3-.5.4l-.3.3v1.4h-.4v-4.1h.4v2.2l1.1-1.1c.4-.4.7-.8 1.1-1.2h.5c-.3.3-.6.7-.8.9-.3.3-.5.6-.8.8l2 2.4h-.5zM86 24.8c.3.4.5.9.5 1.6 0 .6-.2 1.2-.5 1.6-.3.4-.8.6-1.4.6-.6 0-1-.2-1.4-.6-.3-.4-.5-.9-.5-1.6 0-.6.2-1.2.5-1.6.3-.4.8-.6 1.4-.6.6 0 1.1.2 1.4.6zm-.3 2.9c.3-.3.4-.8.4-1.3s-.1-1-.4-1.3c-.3-.3-.6-.5-1.1-.5-.4 0-.8.2-1.1.5-.3.3-.4.8-.4 1.3s.1 1 .4 1.3c.3.3.6.5 1.1.5.5 0 .9-.2 1.1-.5zM91.3 28.5l-1.2-1.7h-1.3v1.7h-.4v-4.1h1.8c.4 0 .7.1 1 .3.3.2.4.5.4.9 0 .3-.1.5-.3.7-.2.2-.4.3-.7.4l1.2 1.8h-.5zm-.5-2.3c.2-.1.3-.4.3-.6 0-.3-.1-.5-.3-.6-.2-.1-.4-.2-.7-.2h-1.3v1.7h1.3c.3-.1.5-.2.7-.3zM93.4 28.5v-4.1h2.9v.3h-2.5v1.5h2.4v.3h-2.4v1.6h2.5v.4h-2.9zM101.3 28.5l-.5-1.1h-2.2l-.5 1.1h-.4l1.7-4.1h.5l1.7 4.1h-.3zm-1.6-3.7-.9 2.2h1.9l-1-2.2zM106 28.5l-2.3-3.6v3.5h-.4v-4.1h.5l2.3 3.6v-3.6h.4v4.1h-.5zM113.4 24.7v3.8h-.4v-3.8h-1.4v-.3h3.2v.3h-1.4zM119 28.5l-.5-1.1h-2.2l-.5 1.1h-.4l1.7-4.1h.5l1.7 4.1h-.3zm-1.6-3.7-.9 2.2h1.9l-1-2.2zM123.7 26.8c.1.2.2.4.2.6 0 .3-.2.6-.5.8-.3.2-.6.3-1.1.3-.5 0-1-.2-1.2-.5-.3-.3-.4-.6-.4-1h.4c0 .4.1.7.4.8.2.2.5.3.9.3.3 0 .6-.1.8-.2.2-.1.3-.3.4-.6 0-.2 0-.3-.1-.5-.1-.1-.2-.2-.4-.3-.2-.1-.4-.1-.6-.2-.2 0-.4-.1-.6-.2-.3-.1-.5-.2-.6-.4-.1-.2-.2-.4-.2-.7 0-.3.1-.5.4-.8.2-.2.6-.4 1.1-.4.6 0 1 .2 1.2.5.2.3.3.6.3.8h-.4c0-.3-.1-.5-.3-.7-.2-.2-.5-.3-.8-.3-.3 0-.6.1-.7.2-.2.2-.3.3-.3.5s.1.4.2.5c.1.1.3.2.4.2.1 0 .3.1.6.1.2 0 .5.1.7.2-.1.7.1.8.2 1zM127 24.7v3.8h-.4v-3.8h-1.4v-.3h3.2v.3H127zM130.1 28.5v-4.1h2.9v.3h-2.5v1.5h2.4v.3h-2.4v1.6h2.5v.4h-2.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThebornkorea);
export default __webpack_public_path__ + "static/media/thebornkorea.cb418748d11140c947bac18b4bf8b62a.svg";
export { ForwardRef as ReactComponent };